import store from '@/store';
export default {
  install: function install(Vue, options) {
    if (options.developmentOff && process.env.NODE_ENV === 'development') return;

    Vue.config.errorHandler = function (error, vm, mes) {
      var info = {
        type: 'script',
        code: 0,
        mes: error.message,
        url: window.location.href
      };
      Vue.nextTick(function () {//加载时错误执行报错的禁用
        //store.dispatch('addErrorLog', info)
      });
    };
  }
};